import styles from './Group.module.css';
import '../../resources/css/admin_style.css';
import NavBar, { NavType } from "../NavBar/NavBar";
import React, { useContext, useEffect, useState } from "react";
import Loading from "../../utils/loading/Loading";
import Header from "../Header/Header";
import { ModalContext } from "../../utils/modal/ModalProvider";
import { IAM_PATH, IAM_SERVER_SERVICE_PRODUCT, IAM_SERVER_SERVICE_LICENSE } from "../../utils/Config";
import axios from "../../utils/api/axios";
import DetailModal from "../../utils/modal/DetailModal";
import { SoftwareDetailModal } from "./modal/SoftwareDetailModal";
import { SoftwareRegisterModal } from "./modal/SoftwareRegisterModal";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { DialogEnum, showDialog } from '../../utils/dialog/Dialog';
import ProductTable from './component/ProductTable';
import { param } from 'jquery';
import { borderBottom } from '@mui/system';
// import { useServiceList } from '../../utils/service/serviceList';
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa'

/**
 * 페이지 권한 관리 화면
 * @param isMobile
 * @param setMovePage
 * @returns {JSX.Element}
 * @constructor
 */
function Product({ isMobile, setMovePage }) {
    const { closeModal } = useContext(ModalContext);

    const { openModal } = useContext(ModalContext);
    const [loading, setLoading] = useState(false);
    const [usersLoading, setUsersLoading] = useState(false);

    //검색 조건
    const [selectedKind, setSelectedKind] = useState("");
    const [searchValue, setSearchValue] = useState('');

    //로그인된 사용자의 서비스 리스트
    // const [serviceList, setServiceList] = useState([]);
    // const {serviceList} = useServiceList();
    //서비스 아이디
    const [selectedServiceId, setSelectedServiceId] = useState('');

    //페이지 데이터, 선택 페이지
    // const [treeData, setTreeData] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    //선택 페이지 권한 목록
    // const [originalGroupUsers, setOriginalGroupUsers] = useState([]); // 최초 서버에서 받아온 권한 리스트(수정 전)
    const [selectedGroupUsers, setSelectedGroupUsers] = useState([]); // 화면에서 수정 중인 권한 리스트(수정 후)

    const [page, setPage] = useState(0);
    const listSize = 10; // 한 페이지당 보여줄 항목 수

    const [totalCount, setTotalCount] = useState(0);

    const [userInfo, setUserInfo] = useState({
        userId: sessionStorage.getItem("userId"),
        userName: sessionStorage.getItem("userName"),
        groupId: sessionStorage.getItem("groupId"),
        role: sessionStorage.getItem("role")
    })

    const [isMobileWindow, setIsMobileWindow] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            setIsMobileWindow(window.innerWidth < 768); // 모바일 기준 너비
        };
        handleResize(); // 초기값
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        fetchData();
    }, []);


    // 데이터 테이블 조회 API
    const fetchData = async (page = 0, size = listSize, searchType, keyword) => {
        const conditions = []
        if (!(searchType == "" || keyword == "")) {
            conditions.push({
                "operator": "AND",
                "conditions": [
                    { "field": searchType, "operator": "like", "value": keyword }
                ]
            });
        }

        const params = {
            startDate: 0,
            endDate: 0,
            page: page,
            size: size,
            sortField: ["id"],
            sortOrder: ["desc"],
            operator: "",
            conditions: conditions
        };

        const url = IAM_PATH + IAM_SERVER_SERVICE_PRODUCT + "/all";
        await axios.post(url, params)
            .then((res) => {
                setTotalCount(res.data.data.totalCount);
                setSelectedGroupUsers(res.data.data.data.map(item => ({ ...item })));
            })
            .catch((e) => {
                console.error(e);
                showDialog(DialogEnum.DEFAULT, "실패", "사용자 정보 조회에 실패했습니다.");
            })
            .finally(() => {
                setUsersLoading(false);
            });

    };

    const transformToTreeData = (data) => {
        return data.map(item => ({
            title: item.groupName,   // 트리에 표시될 텍스트
            // key: item.groupId.toString(), // 고유한 키 (문자열 추천)
            key: item.id, // 고유한 키 (문자열 추천)
            // userCount: item.userCount,
            children: item.children ? transformToTreeData(item.children) : []
        }));
    };

    // const handleServiceChange = (e) => {
    //     const selected = e.target.value;
    //     setSelectedServiceId(selected);
    //     setSelectedGroup(null); // 서비스 변경 시 선택된 페이지 초기화
    // };

    const handleSelect = (selectedKeys, info) => {
        setPage(0)

        if (!info || !info.node) {
            console.warn('handleSelect: info or info.node is undefined!', info);
            return;
        }

        const selected = info.node;
        setSelectedGroup(selected);
        setSelectedGroupUsers([]); // ← 미리 초기화!
        getGroupUsersAll(info.node.key);
    };

    const getGroupUsersAll = () => {

    }

    useEffect(() => {
        fetchData(page, listSize);
    }, [page]);

    const handleNextPage = () => {
        setPage((prevPage) => {
            const newPage = prevPage + 1;
            return newPage;
        });
    };

    const handlePrevPage = () => {
        setPage((prevPage) => {
            const newPage = Math.max(prevPage - 1, 0);
            return newPage;
        });
    };

    const handleSearch = (searchType, keyword) => {
        setPage(0);
        fetchData(0, listSize, searchType, keyword)
    };


    // 권한만 다시 가져오는 함수
    const reloadGoupUsres = () => {
        fetchData(0, listSize);
    }

    // 그룹 유저 추가 모달 핸들러
    const handleAddGroupUsers = () => {
        //그룹 선택해서 넘어가야함
        const modalContent = <SoftwareRegisterModal update={reloadGoupUsres}
            selectedServiceId={selectedServiceId} groupId={selectedGroup != null ? selectedGroup.key : ""} />
        const modalOption = { modalTitle: '제품 등록' }
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    };

    // 그룹 유저 삭제
    const handleDeleteGroupUsers = (selectedIds) => {
        const url = IAM_PATH + IAM_SERVER_SERVICE_PRODUCT + "/delete";
        axios.post(url, { ids: selectedIds })
            .then((res) => {
                showDialog(DialogEnum.SUCCESS, res.data.code == 200 ? "성공" : "실패", res.data.message, res.data.code == 200 ? closeModal : undefined);
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            })
            .finally(() => {
                //reload 안됨
                reloadGoupUsres();
            });
    };

    const handleRowClick = (id) => {
        const modalContent = <SoftwareDetailModal id={id} update={reloadGoupUsres} />
        const modalOption = { modalTitle: '제품 상세정보' }
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    };

    //----------------------------------------------------
    // // 삭제
    // const handleDeleteSelected = () => {
    //     if (selected.length > 0) {
    //     onDeleteUsers(selected); // 리스트로 넘김
    //     setSelected([]);
    //     }
    // };

    //----------------------------------------------------

    const [showGroupTree, setShowGroupTree] = useState(true);

    return (
        <div className={"adminWrap"}>
            <NavBar type={NavType.PRODUCT} />
            <section className={"rightCont"}>
                <Header />
                <div className={"rightCont__cont"}>
                    <h2 className={styles.sectionTitle}>· 제품 관리</h2>
                    <div style={{ display: "flex" }}>
                        <div className={styles.rightCont__cont__tableWrap} style={{ flex: "1" }}>
                            <div className={styles.permissionPanel}>
                                <ProductTable
                                    groupId={selectedGroup != null ? selectedGroup.key : ""}
                                    users={selectedGroupUsers}
                                    onAddUser={handleAddGroupUsers}
                                    onDeleteUsers={handleDeleteGroupUsers}
                                    detailUser={handleRowClick}
                                    onPrevPage={handlePrevPage}
                                    onNextPage={handleNextPage}
                                    disablePrev={page === 0}
                                    disableNext={(page + 1) * listSize >= totalCount}
                                    pageNumber={page}
                                    totalCount={totalCount}
                                    listSize={listSize}
                                    searchValue={searchValue}
                                    setSearchValue={setSearchValue}
                                    onSearch={handleSearch}
                                    isMobileWindow={isMobileWindow}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <p className={"rightCont__cont__copyright"}> ⓒ 2025. Innocode. All rights reserved.</p> */}
                </div>
            </section>

        </div>
    )
}

export default Product;